import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { getLastResults, getDetailResults } from "../../../../apiservices/CasionApi";
import RefResultModal from "../../../casinoComponents/refResultModal";
import TrioResultBody from "../../../casinoComponents/refResultModal/TrioResultBody";
import { formatRefMatchTime } from "../../../../utils/refMatchTime";

/**
 * Last Result items for Trio / V-Trio in the reference markup (inside .casino-video-last-results):
 *   every round is a plain <span> " R " (no class).
 * Click → .loader-overlay (in .page-content) while the round detail loads, then the
 * reference result modal ("{ename} Result", modal-xl, .casino-result) with TrioResultBody.
 * Refetches when the round id changes (reference: getLastResults on a new mid).
 */
export default function TrioRefResults({ gameType = "trio", fallbackTitle = "Trio", roundId }) {
  const apiType = String(gameType || "trio").toLowerCase().trim();
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        const res = response?.data?.data?.res;
        if (alive && Array.isArray(res)) setLastResults(res);
      } catch (e) {
        console.error("Error fetching last results:", e);
      }
    };
    fetchLastResults();
    return () => {
      alive = false;
    };
  }, [apiType, roundId]);

  const handleResultClick = async (mid) => {
    if (loading || !mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, String(mid));
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (e) {
      console.error("Error fetching detail results:", e);
    }
    setLoading(false);
  };

  return (
    <>
      {lastResults.map((r, i) => (
        <span key={`${r?.mid}-${i}`} onClick={() => handleResultClick(r?.mid)}>
          {" R "}
        </span>
      ))}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector(".page-content") || document.body)}
      <RefResultModal
        show={showModal && !!detailResult}
        onHide={() => setShowModal(false)}
        title={`${detailResult?.ename || fallbackTitle} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        {detailResult && <TrioResultBody t1={detailResult} />}
      </RefResultModal>
    </>
  );
}
